import { render, staticRenderFns } from "./ProgramAwardSetupTab.vue?vue&type=template&id=aa44e840&scoped=true&"
import script from "./ProgramAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProgramAwardSetupTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProgramAwardSetupTab.vue?vue&type=style&index=0&id=aa44e840&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa44e840",
  null
  
)

export default component.exports